import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import { fetchInventoryAuditLogs } from '../../sagas/routines';
import {
  clearInventoryAuditLogs,
  inventoryAuditLogsOnChangePage
} from '../../actions/audit-log';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState()
};

const clearInventoryAuditLogsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const auditLogsOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchInventoryAuditLogs),
  ...clearInventoryAuditLogsHandler(clearInventoryAuditLogs),
  ...auditLogsOnChangePageHandler(inventoryAuditLogsOnChangePage)
});
